<mat-form-field appearance="outline" class="custom-field">
  <mat-label>Semana</mat-label>
  <mat-date-range-input [rangePicker]="picker" [max]="max" [min]="min">
    <input matStartDate placeholder="Start date">
    <input matEndDate placeholder="End date">
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
